import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-magicbag-reward-modal',
  templateUrl: './magicbag-reward.component.html',
  styleUrls: ['./magicbag-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, ButtonComponent, SharedModule],
})
export class MagicBagRewardModalComponent implements OnInit {
  magicBagRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);

  lang: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.magicBagRewardModalData.id, ModalType.Persisted, this.magicBagRewardModalData)
    );
  }
}
